import { cx } from '@libs/classnames';
import { AnimatedNode } from '@ui/components/Animation';
import { Button } from '@ui/components/Button';

import {
  ButtonAnalize,
  ButtonCancelGame,
  ButtonClaimVictory,
  ButtonDraw,
  ButtonPlayAgain,
  ButtonRematch,
  ButtonResign,
} from '@features/game/ui/GameButtons/GameButtons';

import styles from './GameActions.module.css';

export function GameActions({
  isFirstMove,
  isRating,
  isPlaying,
  canRequestDraw,
  canResign,
  canClaimVictory,
  canAnalyze,
  canRematch,
  canFindNew,
  newOpponentDisabled,
  isSearching,
  rematchWaiting,
  rematchOpponentOffered,
  onCancelGame,
  onDraw,
  onResign,
  onClaimVictory,
  onNewOpponent,
  onNewSearch,
  onAnalize,
  onRematch,
  onClose,
}: {
  isFirstMove?: boolean;
  isRating?: boolean;
  isPlaying?: boolean;
  canRequestDraw?: boolean;
  canResign?: boolean;
  canClaimVictory?: boolean;
  canAnalyze?: boolean;
  canRematch?: boolean;
  canFindNew?: boolean;
  newOpponentDisabled?: boolean;
  isSearching?: boolean;
  rematchWaiting?: boolean;
  rematchOpponentOffered?: boolean;
  onCancelGame?: () => void;
  onDraw?: () => void;
  onResign?: () => void;
  onClaimVictory?: () => void;
  onNewOpponent?: () => void;
  onNewSearch?: () => void;
  onAnalize?: () => void;
  onRematch?: () => void;
  onClose?: () => void;
}) {
  if (isFirstMove && isPlaying) {
    return (
      <div className={cx(styles.actions, styles.is_first_move)}>
        <ButtonCancelGame onClick={onCancelGame}>Отменить партию</ButtonCancelGame>
        {isRating && <p>Отказ до первого хода не&nbsp;повлияет на ваш рейтинг</p>}
      </div>
    );
  }

  return isPlaying ? (
    <div className={cx(styles.actions, styles.is_playing)}>
      <AnimatedNode>
        {canClaimVictory && <ButtonClaimVictory onClick={onClaimVictory} />}
      </AnimatedNode>
      <ButtonDraw disabled={!canRequestDraw} onClick={onDraw} />
      <ButtonResign disabled={!canResign} onClick={onResign} />
    </div>
  ) : (
    <div className={cx(styles.actions, styles.is_watching)}>
      {canRematch && (
        <ButtonRematch
          disabled={rematchWaiting}
          highlight={rematchOpponentOffered}
          onClick={onRematch}
        >
          {rematchWaiting ? 'Ожидание...' : 'Реванш'}
        </ButtonRematch>
      )}
      {canAnalyze && <ButtonAnalize onClick={onAnalize}>Анализ</ButtonAnalize>}
      {canFindNew ? (
        <ButtonPlayAgain
          disabled={newOpponentDisabled}
          onClick={onNewOpponent}
          onSettings={onNewSearch}
        >
          {isSearching ? 'Поиск...' : 'Новый соперник'}
        </ButtonPlayAgain>
      ) : (
        <Button onClick={onClose}>Вернуться</Button>
      )}
    </div>
  );
}
